import { render, staticRenderFns } from "./o-clients.vue?vue&type=template&id=5e00fda5"
import script from "./o-clients.vue?vue&type=script&lang=js"
export * from "./o-clients.vue?vue&type=script&lang=js"
import style0 from "./o-clients.vue?vue&type=style&index=0&id=5e00fda5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports